interface JWTPayload {
  userId: number;
  role: string;
  iat: number;
  exp: number;
  iss?: string;
}

export function parseJWT(token: string): JWTPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }

    const payloadB64 = parts[1];
    const payload = JSON.parse(atob(payloadB64)) as JWTPayload;
    return payload;
  } catch {
    return null;
  }
}

export function isTokenExpired(token: string): boolean {
  const payload = parseJWT(token);
  if (!payload) {
    return true;
  }

  const now = Math.floor(Date.now() / 1000);
  return payload.exp < now;
}

export function getTokenExpirationTime(token: string): Date | null {
  const payload = parseJWT(token);
  if (!payload) {
    return null;
  }

  return new Date(payload.exp * 1000);
}

export function getTimeUntilExpiration(token: string): number {
  const expiration = getTokenExpirationTime(token);
  if (!expiration) {
    return 0;
  }

  return expiration.getTime() - Date.now();
}

export function formatTimeRemaining(token: string): string {
  const remainingMs = getTimeUntilExpiration(token);
  if (remainingMs <= 0) {
    return 'Oturum süresi doldu';
  }

  const days = Math.floor(remainingMs / (1000 * 60 * 60 * 24));
  const hours = Math.floor((remainingMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((remainingMs % (1000 * 60 * 60)) / (1000 * 60));

  if (days > 0) {
    return `${days} gün`;
  }
  if (hours > 0) {
    return `${hours} saat`;
  }
  return `${minutes} dakika`;
}
